const SCALE = 8

export const UNIT = 19.05 * SCALE

export const BASE_SIZE = 18 * SCALE
export const BASE_RADIUS = BASE_SIZE / 12

export const DISH_SIZE = 12 * SCALE
export const DISH_RADIUS = DISH_SIZE / 6
